import React from 'react';
import { Text } from 'Components/frameworks/text/Text';
export type ProductFeatureDetailInformationProps = {
  className?: string;
  description: string;
  label?: string;
};
export function ProductFeatureDetailInformation(props: ProductFeatureDetailInformationProps) {
  const { className, description, label } = props;

  if (!description) {
    return null;
  }

  return (
    <article className={className}>
      {!!label && <div className="font-sans text-12 font-bold text-black">{label}: </div>}
      <Text className="text-darkGrey" text={description} theme="text-sans-n2" />
    </article>
  );
}
